export default {
  types: {
    A: {
      title: 'Motorcycle',
      passengers: '1-2 passengers',
      name: 'Motorcycle / 1-2 passengers / {price}',
    },
    B: {
      title: 'Private car',
      passengers: '1-5 passengers',
      name: 'Private car / 1-5 passengers / {price}',
    },
    C: {
      title: 'Larger private car',
      passengers: '6-9 passengers',
      name: 'Larger private car / 6-9 passengers / {price}',
    },
    D: {
      title: 'Minibus',
      passengers: '10-19 passengers',
      name: 'Minibus / 10-19 passengers / {price}',
    },
    E: {
      title: 'Bus',
      passengers: '20-32 passengers',
      name: 'Bus / 20-32 passengers / {price}',
    },
    F: {
      title: 'Large bus',
      passengers: '33 passengers and over',
      name: 'Large bus / 33 passengers and over / {price}',
    },
    G: {
      title: 'Larger car',
      passengers: '6 passengers and over',
      name: 'Larger car / 6 passengers and over / {price}',
    },
    S26: {
      title: 'Summerpass',
      passengers: '1-5 passengers',
      name: 'Private car / 1-5 passengers / {price}',
    },
  },
  instructions: {
    title: 'When you enter and exit the parking lot area we read your car license plate to check if you have payed the service fee.',
    step1: 'Select your vehicle type',
    step2: 'Enter your vehicle plate number',
    step3: 'Enter your email for a receipt',
    note: 'There is no need to put a printed ticket in your car window.',
    example: 'Example of a car plate for a vehicle: ',
    plate: 'ABC12',
  },
  complete: {
    thankYou: 'Thank you',
    success: 'Payment was successful',
    total: 'Total',
    receipt: 'Receipt was sent to the email:',
    reset: 'Pay for another parking spot',
  },
  dialogs: {
    plate: {
      title: 'Licence plate',
      licencePlate: 'Licence plate',
      email: 'Send a receipt to this email',
      continue: 'Continue',
      cancel: 'Cancel',
    },
  },
  payment: {
    form: {
      name: 'Cardholders name *',
      card: 'Card number *',
      expire: 'Expiration date *',
      ccv: 'CVC *',
      terms: 'Click here to read the terms and conditions.',
      toc: 'I have read and I accept the terms and conditions *',
      email: 'Email *',
      back: 'Go back',
      confirm: 'Finish and pay',
      payment: 'Payment information',
    },
    information: {
      payment: 'Payment for',
      total: 'Amount',
    },
    secure3d: {
      hint: 'Press "Send" to begin a strong customer authentication (SCA) on your payment.',
      about: 'What is strong customer authentication (SCA)?',
      submit: 'Send',
      cancel: 'Cancel',
    },
  },
  errors: {
    licencePlate: {
      noInput: 'Please input a licence plate and select from the search results',
      invalidEmail: 'Please enter a valid email address',
    },
    payment: {
      name: 'Cardholders name can\'t be empty',
      cardNumber: {
        isEmpty: 'Card number can\'t be empty',
        isToShort: 'Card number is to short',
        isInvalid: 'Value is an invalid card number',
      },
      month: 'Required',
      monthInvalid: 'Invalid month',
      expired: 'Expired',
      year: 'Required',
      ccv: 'Required',
    },
    dialog: {
      default: {
        title: 'Error',
        message: 'Operation returned error: "{error}"',
      },
      networkError: {
        title: 'Connection lost',
        message: 'Couldn\'t connect to service. Please check if the device is connected to the internet.',
      },
      paymentGatewayFailure: {
        title: 'Error from payment gateway',
        message: 'Unable to charge your card. Please check if card details are correct.',
      },
      code: {
        500: {
          title: 'API error',
          message: 'API couldn\'t perform action: "{error}"',
        },
      },
    },
  },
};
